module.exports = __webpack_public_path__ + "static/media/s_v8_t8.eca5a122.mp3";